
export function isBinaryDxf(dxfString: string): boolean {
    const isBinary = dxfString.startsWith('AutoCAD Binary DXF');
    return isBinary;
}

// @ts-ignore
export function binaryDxfBufferToASCIIString(buffer, headerOnly = false): string {
    // @ts-ignore
    function getGroupType(code) {
        if ((0 <= code && code <= 9) || (100 <= code && code <= 109) || (300 <= code && code <= 309) || (410 <= code && code <= 419) || (430 <= code && code <= 439) || (470 <= code && code <= 479) || (1000 <= code && code <= 1009)) return 'string';
        if ((10 <= code && code <= 59) || (110 <= code && code <= 149) || (210 <= code && code <= 239) || (460 <= code && code <= 469) || (1010 <= code && code <= 1059)) return 'double';
        if ((60 <= code && code <= 79) || (170 <= code && code <= 179) || (270 <= code && code <= 289) || (370 <= code && code <= 389) || (400 <= code && code <= 409) || (1060 <= code && code <= 1070)) return 'int16';
        if ((90 <= code && code <= 99) || (420 <= code && code <= 429) || (440 <= code && code <= 449) || (1071 === code) || (180 <= code && code <= 189) || (380 <= code && code <= 389)) return 'int32';
        if ((160 <= code && code <= 169) || (450 <= code && code <= 459)) return 'int64';
        if (290 <= code && code <= 299) return 'boolean';
        if ((310 <= code && code <= 319) || (490 <= code && code <= 499) || (1004 === code)) return 'binary';
        if ((5 === code) || (105 === code) || (320 <= code && code <= 369) || (390 <= code && code <= 399) || (480 <= code && code <= 489)) return 'handle';  // Treated as string (hex)
        return 'unknown';
    }

    // @ts-ignore
    function arraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }


    const uint8 = new Uint8Array(buffer);
    const view = new DataView(buffer);
    const sentinelStr = 'AutoCAD Binary DXF\r\n';
    const sentinel = new TextEncoder().encode(sentinelStr);
    const isBinary = arraysEqual(uint8.subarray(0, 20), sentinel) && uint8[20] === 0x1A && uint8[21] === 0x00;

    if (!isBinary) {
        return new TextDecoder().decode(uint8);
    }

    let position = 22;
    const lines = [];

    while (position < uint8.length) {
        const groupCode = view.getUint16(position, true);
        position += 2;
        const type = getGroupType(groupCode);
        let valueStr;

        switch (type) {
            case 'string':
            case 'handle':  // Handles are hex strings, treated as strings
                let str = '';
                while (position < uint8.length && uint8[position] !== 0) {
                    str += String.fromCharCode(uint8[position]);
                    position++;
                }
                position++;  // Skip NUL
                valueStr = str;
                break;
            case 'double':
                const doubleVal = view.getFloat64(position, true);
                position += 8;
                valueStr = doubleVal.toString();
                break;
            case 'int16':
                const int16Val = view.getInt16(position, true);
                position += 2;
                valueStr = int16Val.toString();
                break;
            case 'int32':
                const int32Val = view.getInt32(position, true);
                position += 4;
                valueStr = int32Val.toString();
                break;
            case 'int64':
                const int64Val = view.getBigInt64(position, true);
                position += 8;
                valueStr = int64Val.toString();
                break;
            case 'boolean':
                const boolVal = uint8[position];
                position += 1;
                valueStr = boolVal ? '1' : '0';
                break;
            case 'binary':
                const len = uint8[position];
                position += 1;
                let hex = '';
                for (let i = 0; i < len; i++) {
                    hex += uint8[position + i].toString(16).padStart(2, '0').toUpperCase();
                }
                position += len;
                valueStr = hex;
                break;
            default:
                throw new Error(`Unsupported group code: ${groupCode}`);
        }

        lines.push(groupCode.toString());
        lines.push(valueStr);

        if (headerOnly) {
            // Upload checks need only the first HEADER section, never geometry.
            if (groupCode === 0 && valueStr === 'ENDSEC') break;
            if (groupCode === 2 && lines[lines.length - 4] === '0'
                && lines[lines.length - 3] === 'SECTION' && valueStr !== 'HEADER') break;
        }
    }

    return lines.join('\r\n');
}
